// ─────────────────────────────────────────────────────────────
// src/hooks/useIndividualCalculator.js
// All state and logic for the individual salary-calculator form.
// ─────────────────────────────────────────────────────────────

import { useState } from "react";
import {
  calculateNetFromGross,
  calculateGrossFromNet,
  validateSalaryInputs,
} from "../utils/taxCalculations";

const INITIAL_INPUTS = { gross: "", net: "", insurance: "" };

/**
 * @param {'netFromGross'|'grossFromNet'} calculationMode
 * @param {object} t  – translation strings (for error messages)
 */
const useIndividualCalculator = (calculationMode, t) => {
  const [inputs,  setInputs]  = useState(INITIAL_INPUTS);
  const [results, setResults] = useState(null);
  const [errors,  setErrors]  = useState({});

  const handleInputChange = (field, value) => {
    setInputs((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleCalculate = () => {
    const validationErrors = validateSalaryInputs(inputs, calculationMode, t);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const insurance = parseFloat(inputs.insurance);

    if (calculationMode === "netFromGross") {
      const gross  = parseFloat(inputs.gross);
      const result = calculateNetFromGross(gross, insurance);
      setResults(result);
    } else {
      const net        = parseFloat(inputs.net);
      const grossSalary = calculateGrossFromNet(net, insurance);
      const result     = calculateNetFromGross(grossSalary, insurance);
      setResults(result);
    }
  };

  const handleReset = () => {
    setInputs(INITIAL_INPUTS);
    setResults(null);
    setErrors({});
  };

  return { inputs, results, errors, handleInputChange, handleCalculate, handleReset };
};

export default useIndividualCalculator;